import { useMe } from "@/hooks/use-auth";
import { useRiderSales } from "@/hooks/use-rider-sales";
import { useWorkspaces } from "@/hooks/use-workspaces";
import { formatLocalDate } from "@/lib/date-utils";

function sixMonthsAgo(): string {
  const today = new Date();
  return formatLocalDate(
    new Date(today.getFullYear(), today.getMonth() - 6, today.getDate()),
  );
}

function today(): string {
  return formatLocalDate(new Date());
}

// Shared by the period picker (per-row + running total while picking) and
// the payroll dialog (live "Gaji Bersih" preview before the draft is
// saved) — both need the same workspace daily wage rate + the same set of
// candidate rider_sales for this rider.
export function useRiderPayrollEstimate(
  riderId: string,
  selectedIds: string[],
) {
  const { data: me } = useMe();
  const { data: workspacesData } = useWorkspaces({ per_page: 100 });
  const dailyWageRate =
    workspacesData?.items.find((w) => w.id === me?.activeWorkspaceId)
      ?.riderDailyWageRate ?? 0;

  const { data: salesData } = useRiderSales(
    riderId
      ? {
          rider_id: riderId,
          date_from: sixMonthsAgo(),
          date_to: today(),
          per_page: 100,
        }
      : undefined,
  );

  const sales = salesData?.items ?? [];
  const selectedSales = sales.filter((s) => selectedIds.includes(s.id));
  const daysWorked = new Set(selectedSales.map((s) => s.date)).size;
  const salesIncomeAmount = selectedSales.reduce(
    (sum, s) => sum + s.totalSalesIncome,
    0,
  );
  const bonusAmount = selectedSales.reduce((sum, s) => sum + s.totalBonus, 0);
  const dailyWageTotal = dailyWageRate * daysWorked;

  return {
    sales,
    salesLoaded: salesData !== undefined,
    dailyWageRate,
    daysWorked,
    dailyWageTotal,
    salesIncomeAmount,
    bonusAmount,
    grossBeforeAdjustments: dailyWageTotal + salesIncomeAmount + bonusAmount,
  };
}
